import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed9c78c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title panel-title" }, " File Explorer ", -1))
const _hoisted_2 = {
  key: 0,
  class: "file-menu"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "New File", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit File Name", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "disabled" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Edit File Name", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open File...", -1))
const _hoisted_10 = ["accept"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open Workspace...", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Folder", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Import Contract from TX", -1))
const _hoisted_14 = { class: "file-menu" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Download File", -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "disabled" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Download File", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Download Workspace", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title panel-title" }, " Files In Workspace ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open File: Select Location", -1))
const _hoisted_23 = { class: "form-input" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Workspace Location", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "/" }, "/", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "form-input" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "File Name", -1))
const _hoisted_29 = { class: "modal-footer text-right" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open File", -1))
const _hoisted_32 = [
  _hoisted_31
]

import { ref, watchEffect } from 'vue';
import DefaultIcon from '@/components/atomic/DefaultIcon';
import DefaultWorkspace from '@/components/composed/DefaultWorkspace.vue';
import DefaultModal from '@/components/atomic/DefaultModal.vue';
import NewFileDialog from '@/components/dialogs/NewFileDialog.vue';
import EditFileNameDialog from '@/components/dialogs/EditFileNameDialog.vue';
import NewFolderDialog from '@/components/dialogs/NewFolderDialog.vue';
import LoadContractFromTxDialog from '@/components/dialogs/LoadContractFromTxDialog.vue';
import FileList from '@/components/atomic/FileList.vue';
import fileDownload from 'js-file-download';
import { EditorViewMetadata } from '@/core/interfaces/EditorViewMetadata';
import { createToast } from 'mosha-vue-toastify';
import { JSZipWrapper } from '@/core/JSZipWrapper';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileExplorer',
  props: {
	workspace: Object,
	tx: String,
	login: Object,
	networkParam: String
},
  setup(__props) {

const props = __props;

const showModalLoadContractFromTx = ref(false);
const showModalAddFolder = ref(false);
const showModalNewFile = ref(false);
const showModalOpenFile = ref(false);
const showModalEditFile = ref(false);
const acceptedFileTypes = ref('.json,application/json,.js,text/javascript,.ts,.py,rs,.java,.cpp,.erl,.go,.html,.xml,.graphql,.gql,.sql,.css,.scss');



const openFile = (inputId: string) => {
	if (document.getElementById(inputId)) {
		document.getElementById(inputId).click();
	}
};
const openFile_helper = (inputEvent: Event): Promise<string> => {
	txtOpenFileContent.value = '';
  const method = new Promise<string>((resolve, reject) => {
     // Transform .json file into key
     try {
      const file = inputEvent.target.files.length ? 
        inputEvent.target.files[0] : null;

      const freader = new FileReader();
			freader.onload = async () => {
				const res = freader.result;
				const fname = file.name;
				selOpenFileLocation.value = '/';
				txtOpenFileContent.value = res;
				txtOpenFileName.value = fname;
				// workspace.addEditor(inputEvent, false, res, fname);
				showModalOpenFileOpen();

				inputEvent.target.value = '';
				resolve(res);
			};
			freader.onerror = () => {
				showModalOpenFile.value = false;
				throw Error('Error reading file');
			};
			freader.readAsText(file);
     } catch (error) {
			showModalOpenFile.value = false;
			createToast(`${error}`,
			{
				type: 'danger',
				showIcon: true,
				position: 'bottom-right',
			});
			reject(error);
     }
  });
  return method;
};


const openWorkspace = (inputId: string) => {
	if (document.getElementById(inputId)) {
		document.getElementById(inputId).click();
	}
};
const openWorkspace_helper = (inputEvent: Event): Promise<void> => {
	txtOpenFileContent.value = '';
	const zip = new JSZipWrapper();
  const method = new Promise<string>((resolve, reject) => {
		const zipFile = inputEvent.target.files.length ? 
			inputEvent.target.files[0] : null;
		zip.openZip(zipFile).then((zFile) => {
			const files = [];

			zFile.forEach(function (relativePath, zipEntry) {
				if (zipEntry.dir) {
          const fullPath = zipEntry.name.slice(0, -1);
          createDirectoryStructureFromPath(fullPath);
				} else {
					files.push(zipEntry);
				}
			});

			// Add files
			for (const file of files) {
				const emptyEvent = new Event('emptyEvent');
				const fragments = file.name.split('/');
				const realFName = fragments[fragments.length - 1];
				const path = '/' + file.name.substring(0, file.name.length - (realFName.length + 1));
				
				zFile.file(file.name).async("string").then((data) => {
					props.workspace.addEditor(
						emptyEvent,
						false,
						data,
						realFName,
						path,
						false);
				}).catch((error) => {
					console.error('zipFE:', error);
				})

				
			}
			resolve();
		}).catch((error) => {
			showModalOpenFile.value = false;
			createToast(`${error}`,
			{
				type: 'danger',
				showIcon: true,
				position: 'bottom-right',
			});
			reject(error);
		});

		
     
  });
  return method;
};

const openFileModal = (
	inputEvent: Event,
	workspace: DefaultWorkspace,
	fileName: string,
	path: string,
	content='') => {
	const onlyInParent= false;
	workspace.addEditor(inputEvent, onlyInParent, content, fileName, path);
	txtOpenFileContent.value = '';
	showModalOpenFile.value = false;
};

const createDirectoryStructureFromPath = (path: string) => {
  const elements = path.split('/');
  let tmpPath = '';
  for (const e of elements) {
    try {
      props.workspace.addFolder(tmpPath ? tmpPath : '/', e, true);
      tmpPath += `/${e}`;
    } catch (err) {
      console.log('dirStructure:', err);
    }
  }
};


const getEditor = (editorId: number, workspace: DefaultWorkspace): string => {
	const i = workspace.editors.findIndex(ed => ed.id == editorId);
	return workspace.editors[i];
};


const downloadFile = (doc: EditorViewMetadata) => {
	fileDownload(doc.view.state.doc.toString(), doc.name);
}

const downloadWorkspace = async () => {
	const zip = new JSZipWrapper();
	// Get workspace tree
	const editors = props.workspace.editors;
	const fileTreeRoot = props.workspace.getFileTree();
	
	// Load tree to zip
	zip.loadTreeToZip(fileTreeRoot, fileTreeRoot.name, editors);

	// Download file
	const date = new Date();
	const dateF = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`;
	await zip.downloadZip(`arcode_workspace_${dateF}.zip`);
}
const txtOpenFileName = ref('');
const txtOpenFileContent = ref('');
const selOpenFileLocation = ref('/');
watchEffect(() => {
	const r = new RegExp('/|\\\\', 'g');
	txtOpenFileName.value = txtOpenFileName.value.replace(r, '');
});

const showModalNewFileOpen = () => {
	showModalNewFile.value = true;
};

const showModalEditFileOpen = () => {
	showModalEditFile.value = true;
};

const showModalAddFolderOpen = () => {
	showModalAddFolder.value = true;
};

const showModalLoadContractFromTxOpen = () => {
	showModalLoadContractFromTx.value = true;
};

const showModalOpenFileOpen = () => {
	showModalOpenFile.value = true;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (__props.workspace)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              tabindex: "0",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showModalNewFileOpen()))
            }, [
              _createVNode(_unref(DefaultIcon), {
                class: "menu-icon",
                icon: "codicon-new-file"
              }),
              _hoisted_3
            ])
          ]),
          (__props.workspace.getCurrentEditorId() >= 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createElementVNode("button", {
                  tabindex: "0",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showModalEditFileOpen()))
                }, [
                  _createVNode(_unref(DefaultIcon), {
                    class: "menu-icon",
                    icon: "codicon-edit"
                  }),
                  _hoisted_5
                ])
              ]))
            : (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, [
                  _createVNode(_unref(DefaultIcon), {
                    class: "menu-icon",
                    icon: "codicon-edit"
                  }),
                  _hoisted_8
                ])
              ])),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              tabindex: "0",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openFile('txt_file_openFile')))
            }, [
              _createVNode(_unref(DefaultIcon), {
                class: "menu-icon",
                icon: "codicon-folder-opened"
              }),
              _hoisted_9
            ]),
            _createElementVNode("input", {
              type: "file",
              id: "txt_file_openFile",
              style: {"display":"none"},
              accept: acceptedFileTypes.value,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (openFile_helper($event, __props.workspace)))
            }, null, 40, _hoisted_10)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              tabindex: "0",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (openWorkspace('txt_file_openWorkspace')))
            }, [
              _createVNode(_unref(DefaultIcon), {
                class: "menu-icon",
                icon: "codicon-root-folder-opened"
              }),
              _hoisted_11
            ]),
            _createElementVNode("input", {
              type: "file",
              id: "txt_file_openWorkspace",
              style: {"display":"none"},
              accept: ".zip,application/zip",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (openWorkspace_helper($event)))
            }, null, 32)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              tabindex: "0",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (showModalAddFolderOpen()))
            }, [
              _createVNode(_unref(DefaultIcon), {
                class: "menu-icon",
                icon: "codicon-new-folder"
              }),
              _hoisted_12
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              tabindex: "0",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (showModalLoadContractFromTxOpen()))
            }, [
              _createVNode(_unref(DefaultIcon), {
                class: "menu-icon",
                icon: "codicon-mirror"
              }),
              _hoisted_13
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_14, [
      (__props.workspace.getCurrentEditorId() >= 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
            _createElementVNode("button", {
              tabindex: "0",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (downloadFile(getEditor(__props.workspace.getCurrentEditorId(), __props.workspace))))
            }, [
              _createVNode(_unref(DefaultIcon), {
                class: "menu-icon",
                icon: "codicon-desktop-download"
              }),
              _hoisted_16
            ])
          ]))
        : (_openBlock(), _createElementBlock("li", _hoisted_17, [
            _createElementVNode("button", _hoisted_18, [
              _createVNode(_unref(DefaultIcon), {
                class: "menu-icon",
                icon: "codicon-desktop-download"
              }),
              _hoisted_19
            ])
          ])),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          tabindex: "0",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (downloadWorkspace()))
        }, [
          _createVNode(_unref(DefaultIcon), {
            class: "menu-icon",
            icon: "codicon-file-zip"
          }),
          _hoisted_20
        ])
      ])
    ]),
    _hoisted_21,
    (__props.workspace)
      ? (_openBlock(), _createBlock(FileList, {
          key: 1,
          workspace: __props.workspace,
          level: 0,
          fileTree: __props.workspace.getFileTree()
        }, null, 8, ["workspace", "fileTree"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createVNode(LoadContractFromTxDialog, {
          show: showModalLoadContractFromTx.value,
          workspace: __props.workspace,
          tx: __props.tx,
          networkParam: __props.networkParam,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (showModalLoadContractFromTx.value = false))
        }, null, 8, ["show", "workspace", "tx", "networkParam"])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createVNode(NewFolderDialog, {
          show: showModalAddFolder.value,
          workspace: __props.workspace,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (showModalAddFolder.value = false))
        }, null, 8, ["show", "workspace"])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createVNode(NewFileDialog, {
          show: showModalNewFile.value,
          workspace: __props.workspace,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (showModalNewFile.value = false))
        }, null, 8, ["show", "workspace"])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showModalOpenFile.value)
          ? (_openBlock(), _createBlock(DefaultModal, {
              key: 0,
              onClose: _cache[18] || (_cache[18] = ($event: any) => (showModalOpenFile.value = false))
            }, {
              header: _withCtx(() => [
                _createElementVNode("h3", null, [
                  _createVNode(_unref(DefaultIcon), {
                    class: "title-icon",
                    icon: "codicon-folder-opened"
                  }),
                  _hoisted_22
                ])
              ]),
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selOpenFileLocation).value = $event))
                  }, [
                    _hoisted_25,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreePaths(), (path) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
                        path
                          ? (_openBlock(), _createElementBlock("option", {
                              key: 0,
                              value: path
                            }, _toDisplayString(path), 9, _hoisted_26))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 512), [
                    [
                      _vModelSelect,
                      selOpenFileLocation.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((txtOpenFileName).value = $event)),
                    onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (openFileModal($event, __props.workspace, txtOpenFileName.value, selOpenFileLocation.value, txtOpenFileContent.value)), ["enter"])),
                    type: "text"
                  }, null, 544), [
                    [
                      _vModelText,
                      txtOpenFileName.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_29, [
                  (__props.workspace)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["modal-button", { 'modal-button-primary': txtOpenFileName.value }]),
                        disabled: !txtOpenFileName.value,
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (openFileModal($event, __props.workspace, txtOpenFileName.value, selOpenFileLocation.value, txtOpenFileContent.value)))
                      }, _hoisted_32, 10, _hoisted_30))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "modal-button",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (showModalOpenFile.value = false))
                  }, " Close ")
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createVNode(EditFileNameDialog, {
          show: showModalEditFile.value,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (showModalEditFile.value = false)),
          workspace: __props.workspace
        }, null, 8, ["show", "workspace"])
      ]),
      _: 1
    })
  ], 64))
}
}

})